import { Component } from '@angular/core';
import { IonSpinner } from '@ionic/angular/standalone';

@Component({
  selector: 'mtjr-loading',
  imports: [IonSpinner],
  template: `
    <div class="flex h-full !pt-6">
      <ion-spinner name="circles" class="m-auto h-10 w-10" />
    </div>
  `,
})
export class VxLoadingComponent {}
